import { useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { ArrowUUpLeft, MagnifyingGlass } from "@phosphor-icons/react";
import { lies, schick } from "../api/client";
import { datum } from "../lib/format";
import { Dialog, Meldung } from "./Bausteine";

interface Geschlossen {
  id: string;
  nummer: string;
  titel: string;
  text: string;
  status: "erledigt" | "entfallen";
  thema: string;
  geschlossen_nr: number | null;
  geschlossen_am: string | null;
}

/** Erledigte und entfallene Punkte zurück in den Entwurf holen (Rückmeldung 24.10.2026):
 *  mit alter Nummer und Verlauf, wieder offen. */
export function Zurueckholen({ besprechungId, zu, fertig }: { besprechungId: string; zu: () => void; fertig: () => void }) {
  const [q, setQ] = useState("");
  const liste = useQuery({
    queryKey: ["geschlossene-punkte", besprechungId],
    queryFn: () => lies<Geschlossen[]>(`/besprechungen/${besprechungId}/geschlossene-punkte`),
  });
  const holen = useMutation({
    mutationFn: (punktId: string) => schick(`/besprechungen/${besprechungId}/zurueckholen`, { punkt_id: punktId }),
    onSuccess: () => { fertig(); zu(); },
  });
  const nadel = q.trim().toLowerCase();
  const sichtbar = (liste.data ?? []).filter((p) =>
    !nadel || `${p.nummer} ${p.titel} ${p.text} ${p.thema}`.toLowerCase().includes(nadel));
  return (
    <Dialog offen zu={zu} titel="Punkt zurückholen" fuss={<button className="knopf" onClick={zu}>Schließen</button>}>
      <p className="mute" style={{ marginTop: 0 }}>Erledigte und entfallene Punkte kommen mit ihrer alten Nummer und ihrem
        Verlauf wieder in dieses Protokoll und sind dann wieder offen.</p>
      <label className="suche" style={{ width: "100%", marginBottom: 8 }}>
        <MagnifyingGlass size={16} />
        <input className="eingabe" autoFocus placeholder="Nummer oder Text" value={q} onChange={(e) => setQ(e.target.value)} />
      </label>
      <div className="liste zurueck-liste">
        {sichtbar.map((p) => (
          <div key={p.id} className="zeile">
            <span className="nr ziffern">{p.nummer}</span>
            <div className="haupt">
              <div>{p.titel || p.text || "(ohne Text)"}</div>
              <div className="mute">{p.status}{p.geschlossen_nr ? ` in Nr. ${p.geschlossen_nr} (${datum(p.geschlossen_am)})` : ""} · {p.thema}</div>
            </div>
            <button className="knopf" disabled={holen.isPending} onClick={() => holen.mutate(p.id)}>
              <ArrowUUpLeft size={15} /> Zurückholen</button>
          </div>
        ))}
        {liste.isSuccess && sichtbar.length === 0 && <div className="leer">{nadel ? "Nichts gefunden." : "Keine erledigten Punkte."}</div>}
      </div>
      <Meldung fehler={liste.error || holen.error} />
    </Dialog>
  );
}
